export var findFirstAvailableMarket = function (markets, ids) {
    var market, len = ids.length;
    var _loop_1 = function (i) {
        market = markets.find(function (m) {
            return m.marketType.id === ids[i];
        });
        if (market) {
            return "break";
        }
    };
    for (var i = 0; i < len; i += 1) {
        var state_1 = _loop_1(i);
        if (state_1 === "break")
            break;
    }
    return market;
};
//# sourceMappingURL=findFirstAvailableMarket.js.map